export default {
  mounted() {
    if (this.$el.tagName === 'BUTTON') {
      this.$el.addEventListener('click', () => {
        this.$el.disabled = true;
        setTimeout(() => {
          this.$el.disabled = false;
        }, 2000);
      });
    }
  },
};
